module.exports = __webpack_public_path__ + "img/top-border-lc.192d56c4.png";